import Component from "inferno-component";
import "./registerServiceWorker";
import "./App.css";
import PerfectScrollbar from "perfect-scrollbar";


// "string".split( "" ).map( c => c.charCodeAt(0) ).map( c => String.fromCharCode( c ) ).join( "" )
const reconstitute = a => a.map( c => String.fromCharCode( c ) ).join( "" );


export default class App extends Component {
   constructor( props ) {
      super( props );

      this.onResize = this.onResize.bind( this );
      this.state = { clicked: false };
      this.onClick = this.onClick.bind( this );
   }


   onResize() {
      this.ps.update();
   }


   componentDidMount() {
      window.addEventListener( "resize", this.onResize );

      this.ps = new PerfectScrollbar( ".App-main" );
   }


   componentWillUnmount() {
      window.removeEventListener( "resize", this.onResize );

      this.ps.destroy();

      delete( this.ps );
   }


   onClick( e ) {
      if ( !this.state.clicked ) {
         this.setState( { clicked: true } );

         e.preventDefault();
      }
   }


   render() {
      const clicked = this.state.clicked;
      const mail = !clicked ? "Reveal" : reconstitute( [ 116, 104, 119, 97, 114, 116, 64, 105, 110, 51, 115, 46, 99, 111, 109 ] ); // HARD-CODED
      // eslint-disable-next-line
      const anchor = !clicked ? <a href="javascript:void(0)" onClick={this.onClick}>{mail}</a> : <a href={`mailto:${mail}`} target="_blank">{mail}</a>;

      return (
         <div className="App">
            <header className="App-header">
               Induction Internet Infrastructure Services
            </header>

            <main className="App-main">
               {this.props.children}
            </main>

            <footer className="App-footer">
               Contact: {anchor}
            </footer>
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/App.js